import React from "react";

interface IProps {
  theme?: "light" | "dark"
}

export const YouTubeIcon = ({ theme }:IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.5788 11.8541L9.29289 8.60262C8.78216 8.33857 8 8.59481 8 9.24791V15.7492C8 16.3351 8.72681 16.6882 9.29289 16.3945L15.5788 13.1446C16.1395 12.8556 16.1413 12.1431 15.5788 11.8541Z"
        fill={theme === "light" ? "black" : "white"}
      />
      <path
        d="M1 6.83333C1 6.08189 1.27656 5.36122 1.76884 4.82986C2.26113 4.29851 2.92881 4 3.625 4H19.375C20.0712 4 20.7389 4.29851 21.2312 4.82986C21.7234 5.36122 22 6.08189 22 6.83333V18.1667C22 18.9181 21.7234 19.6388 21.2312 20.1701C20.7389 20.7015 20.0712 21 19.375 21H3.625C2.92881 21 2.26113 20.7015 1.76884 20.1701C1.27656 19.6388 1 18.9181 1 18.1667V6.83333ZM20.6875 6.83333C20.6875 6.45761 20.5492 6.09728 20.3031 5.8316C20.0569 5.56592 19.7231 5.41667 19.375 5.41667H3.625C3.2769 5.41667 2.94306 5.56592 2.69692 5.8316C2.45078 6.09728 2.3125 6.45761 2.3125 6.83333V18.1667C2.3125 18.5424 2.45078 18.9027 2.69692 19.1684C2.94306 19.4341 3.2769 19.5833 3.625 19.5833H19.375C19.7231 19.5833 20.0569 19.4341 20.3031 19.1684C20.5492 18.9027 20.6875 18.5424 20.6875 18.1667V6.83333Z"
        fill={theme === "light" ? "black" : "white"}
      />
    </svg>
  );
};
